import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import immutable from 'immutable'

import {LunaLoader} from '../../widgets/lunaloader/lunaloader.component'
import {LunaMapBox} from '../../widgets/lunamapbox.component'
import {ImageGrid} from '../../widgets/imagegrid.component'
import {ItemTitleBlock} from '../../widgets/layout/itemtitleblock.component'
import {ItemOverviewBlock} from '../../widgets/layout/itemoverviewblock.component'
import {RelatedContentBand} from '../../widgets/relatedcontentband/relatedcontentband.component'
import {NextStepHint} from '../../widgets/layout/nextstep.component'

import {AccommodationItem} from '../../accommodations/accommodationitem.component'
import {ActivityItem} from '../../activities/activityitem.component'

const DESTINATION_URL = '/api/v1/destinations/info/'

export class ViewDestination extends React.Component {
    constructor(props) {
        super(props)

        this._isMounted = false

        this.state = {
            hasLoaded: false,
            displayItem: 'destination',
            destination: null,
            accommodation: null,
            activity: null,
            inItin: this.props.activeDestination.get('hasLocation'),
            activeDestinationId: this.props.activeDestination.get('id')
        }

        _.bindAll(this,
            'goBack',
            'goBackToDestinationView',
            'getDestination',
            'addAccommodationFromOverview',
            'onActivateAccommodationInOverview',
            'onActivateActivityInOverview',
            'removeAccommodation',
            'addActivityFromOverview',
            'removeActivity',
            'showDetails'
        )
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    componentWillMount() {
        this._isMounted = true
        // want to set some kind of "we just loaded state"
        // map basic props to state data
        // convert page rendering to use state, not props
    }

    componentWillReceiveProps(nextProps, nextState) {
        if (this.props.activeDestination.get('id') !== nextProps.activeDestination.get('id')) {
            this.getDestination(nextProps.activeDestination.get('id'))
        }
    }

    componentDidMount() {
        this.getDestination(this.props.activeDestination.get('id'))
    }

    getDestination(id) {
        this.setState({hasLoaded: false})
        let self = this
        let requestParams = {
            with: 'opencage,images'
        }
        if (this.props.lunaTrip.get('isLunaTrip') || this.props.lunaTrip.get('fromLunaTrip')) {
            requestParams.slug = this.props.lunaTrip.getIn(['trip', 'slug']) || this.props.lunaTrip.get('fromLunaTrip')
        }
        axios.get(DESTINATION_URL + id + '/', {
            params: requestParams
        }).then(function (response) {
            if (response.data !== undefined) {
                if (self._isMounted) {
                    self.setState({
                        hasLoaded: true,
                        destination: immutable.fromJS(response.data),
                        activeDestinationId: response.data.id
                    })
                }
            } else {
                console.log('ERROR: in getResultByID function')
                console.log(response)
            }
        })
    }

    goBack() {
        this.setState({loaded: false, accommodation: null, activity: null, displayItem: 'destination'})
        this.props.onShowSearch()
    }


    goBackToDestinationView() {
        this.setState({loaded: false, accommodation: null, activity: null, displayItem: 'destination'})
    }

    getGeoParents() {
        if (this.state.hasLoaded) {
            let loc = ''
            if (this.state.destination.getIn(['opencage', 'state'])) {
                loc = this.state.destination.getIn(['opencage', 'state'])
                if (this.state.destination.getIn(['opencage', 'country_code'])) {
                    loc += ', ' + this.state.destination.getIn(['opencage', 'country_code'])
                }
            } else if (this.state.destination.getIn(['opencage', 'country_code'])) {
                loc = this.state.destination.getIn(['opencage', 'country_code'])
            }
            return loc
        }
    }

    addAccommodationFromOverview(accom) {
        if (this.props.leg.getIn(['destination', 'id']) !== this.state.destination.get('id')) {
            // were looking at a new dest. do stuff here
            if (this.props.lastLeg.getIn(['destination', 'id']) === -1) {
                // last leg doesnt have a destination, add it to the last leg
                this.props.onAddDestinationAndAccom(this.props.lastLeg, this.state.destination, accom, this.props.currentUser)
            } else {
                // Else, can we fit another leg in the timeline?
                if (Math.ceil(this.props.lastLeg.getIn(['properties', 'end'])) < this.props.totalDays) {
                    // we can fit a leg in existing timeframe so add one
                    this.props.onAddLegDestinationAndAccom(this.props.lastLeg.getIn(['properties', 'end']), this.state.destination, accom, this.props.currentUser)
                } else {
                    // cant fit it, add a day, then add the leg
                    this.props.onAddDayLegDestinationAndAccom(this.props.lastLeg.getIn(['properties', 'end']), this.state.destination, accom, this.props.currentUser)
                }
            }
        } else if (this.props.leg.getIn(['destination', 'id']) === -1) {
            this.props.onSelectAccommodation(this.props.leg, accom, this.props.currentUser)
            this.props.onSetDestination(this.state.destination)
        } else {
            this.props.onSelectAccommodation(this.props.leg, accom, this.props.currentUser)
        }
    }

    onActivateAccommodationInOverview(accom) {
        this.setState({loaded: false, accommodation: accom, displayItem: 'accommodation'})
    }

    onActivateActivityInOverview(act) {
        this.setState({loaded: false, activity: act, displayItem: 'attraction'})
    }

    showDetails(destination) {
        if (this.props.showDetails) {
            this.props.showDetails(destination)
        } else {
            // overriding this function if we haven't added the leg yet
            if (this.props.leg.getIn(['destination', 'id']) !== -1) {
                this.props.showDetails(destination)
            } else {
                this.getDestination(destination.get('id'))
            }
        }
    }

    removeAccommodation(accom) {
        this.props.onRemoveAccommodation(this.props.leg, accom)
    }

    addActivityFromOverview(act) {
        if (this.props.leg.getIn(['destination', 'id']) !== this.state.destination.get('id')) {
            // were looking at a new dest. do stuff here
            if (this.props.lastLeg.getIn(['destination', 'id']) === -1) {
                // last leg doesnt have a destination, add it to the last leg
                this.props.onAddDestinationAndActivity(this.props.lastLeg, this.state.destination, act, this.props.currentUser)
            } else {
                // Else, can we fit another leg in the timeline?
                if (Math.ceil(this.props.lastLeg.getIn(['properties', 'end'])) < this.props.totalDays) {
                    // we can fit a leg in existing timeframe so add one
                    this.props.onAddLegDestinationAndActivity(this.props.lastLeg.getIn(['properties', 'end']), this.state.destination, act, this.props.currentUser)
                } else {
                    // cant fit it, add a day, then add the leg
                    this.props.onAddDayLegDestinationAndActivity(this.props.lastLeg.getIn(['properties', 'end']), this.state.destination, act, this.props.currentUser)
                }
            }
        } else if (this.props.leg.getIn(['destination', 'id']) === -1) {
            this.props.onSelectActivity(this.props.leg, act, this.props.currentUser)
            this.props.onSetDestination(this.state.destination)
        } else {
            this.props.onSelectActivity(this.props.leg, act, this.props.currentUser)
        }
    }

    removeActivity(act) {
        this.props.onRemoveActivity(this.props.leg, act)
    }

    render() {
        if (!this.state.hasLoaded || !this.state.destination) {
            return <LunaLoader style="basic" triggerFade={this.props.hasLoaded} onFadeLoader={this.onFadeLoader}/>
        } else if (this.state.displayItem === 'accommodation') {
            return <AccommodationItem goBack={this.goBackToDestinationView} leg={this.props.leg}
                                      activeAccommodationId={this.state.accommodation.get('id')}
                                      addToItinFromOverview={this.addAccommodationFromOverview}/>
        } else if (this.state.displayItem === 'attraction') {
            return <ActivityItem goBack={this.goBackToDestinationView} leg={this.props.leg}
                                 activeActivityId={this.state.activity.get('place_id')}
                                 addToItinFromOverview={this.addActivityFromOverview}/>
        } else {
            // converting so we can reuse for added items
            let item = this.state.destination
            let inItin = this.state.inItin
            let backBtn = this.state.inItin ? '' : <a onClick={this.goBack} className="btn">Go Back</a>
            return (
                <div className="view-area">
                    <div className="view-left-col">
                        {backBtn}
                    </div>
                    <div className="view-center">
                        <ItemTitleBlock item={item} leg={this.props.leg} inItin={inItin} type="destination"
                                        removeFromItin={() => {
                                            this.props.onDeleteLeg(this.props.leg)
                                        }} addToItin={() => {
                            this.props.onSetDestination(this.state.destination)
                        }}/>
                        <NextStepHint leg={this.props.leg} inItin={inItin}/>
                        <ImageGrid images={item.get('images')} title={item.get('name')}/>
                        <ItemOverviewBlock label='Overview' body={item.get('description')}/>
                        <RelatedContentBand {...this.props} goBack={this.props.onShowDestination}
                                            onActivateAccommodationInOverview={this.onActivateAccommodationInOverview}
                                            addToItinFromOverview={this.addAccommodationFromOverview} item={item}
                                            destId={this.state.destination.get('id')} addToItin={this.addAccommodation}
                                            removeFromItin={this.removeAccommodation} type="nearby"
                                            model="accommodation"/>
                        <RelatedContentBand {...this.props} goBack={this.props.onShowDestination}
                                            onActivateActivityInOverview={this.onActivateActivityInOverview} item={item}
                                            destId={this.props.activeDestination.get('id')}
                                            addToItinFromOverview={this.addActivityFromOverview}
                                            removeFromItin={this.removeActivity} type="nearby" model="attraction"/>
                        <LunaMapBox item={item}/>
                        <RelatedContentBand {...this.props} showDetails={this.showDetails}
                                            goBack={this.props.onShowDestination} item={item}
                                            destId={this.props.activeDestination.get('id')} type="nearby"
                                            model="destination"/>
                    </div>
                    <div className="view-right-col"/>
                </div>
            )
        }
    }
}